export default class Collapse extends CustomEvent {
    constructor(caller) {
        super('collapse', {
            bubbles: false,
            detail: {
                caller
            }
        });
    }
}
